import { Heart, Sun, Compass as CompassIcon, Users, Lightbulb } from "lucide-react";

const products = [
  {
    name: "Resonance",
    icon: Heart,
    description: "Depth-first dating and friendship. Where connections begin with words, not swipes.",
    status: "Available soon — join waitlist",
    statusColor: "#D85A30",
  },
  {
    name: "Groundwork",
    icon: Sun,
    description: "A daily mental wellness practice for the space between waking up and picking up your phone.",
    status: "Coming 2025",
    statusColor: "#7A7A78",
  },
  {
    name: "Compass",
    icon: CompassIcon,
    description: "Values-based career clarity for people who want work that means something.",
    status: "Coming 2025",
    statusColor: "#7A7A78",
  },
  {
    name: "Village",
    icon: Users,
    description: "Real community for parents. Because it actually takes a village.",
    status: "Coming soon",
    statusColor: "#7A7A78",
  },
  {
    name: "Lantern",
    icon: Lightbulb,
    description: "Life skills nobody taught you. Practical, personal, AI-guided.",
    status: "Coming soon",
    statusColor: "#7A7A78",
  },
];

export default function ProductsSection() {
  return (
    <section
      data-testid="products-section"
      className="py-24 sm:py-32 px-6"
      style={{ backgroundColor: "var(--blush)" }}
    >
      <div className="max-w-6xl mx-auto">
        <h2
          data-testid="products-heading"
          className="text-center mb-16 animate-fade-up"
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "clamp(2rem, 4vw, 2.75rem)",
            fontWeight: 600,
            color: "var(--charcoal)",
            letterSpacing: "-0.01em",
          }}
        >
          Our Products
        </h2>

        {/* Bento grid: top row 2 cards, bottom row 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {products.slice(0, 2).map((product, i) => (
            <ProductCard key={product.name} product={product} delay={i * 100} />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {products.slice(2).map((product, i) => (
            <ProductCard key={product.name} product={product} delay={(i + 2) * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product, delay }) {
  const Icon = product.icon;
  return (
    <div
      data-testid={`product-card-${product.name.toLowerCase()}`}
      className={`product-card animate-fade-up delay-${delay}`}
      style={{
        backgroundColor: "var(--white)",
        borderRadius: "16px",
        padding: "2rem 2rem 1.75rem",
        border: "1px solid rgba(44, 44, 42, 0.06)",
        boxShadow: "0 2px 16px rgba(44, 44, 42, 0.04)",
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          backgroundColor: "var(--coral-light)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1.25rem",
        }}
      >
        <Icon size={22} color="var(--coral)" strokeWidth={1.8} />
      </div>

      <h3
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "1.5rem",
          fontWeight: 600,
          color: "var(--charcoal)",
          marginBottom: "0.625rem",
        }}
      >
        {product.name}
      </h3>

      <p
        style={{
          fontFamily: "var(--font-sans)",
          fontSize: "0.95rem",
          lineHeight: 1.65,
          color: "var(--charcoal-light)",
          marginBottom: "1.25rem",
          fontWeight: 400,
        }}
      >
        {product.description}
      </p>

      <span
        data-testid={`product-status-${product.name.toLowerCase()}`}
        style={{
          display: "inline-block",
          fontFamily: "var(--font-sans)",
          fontSize: "0.75rem",
          fontWeight: 600,
          color: product.statusColor,
          backgroundColor: product.statusColor === "#D85A30" ? "rgba(216,90,48,0.08)" : "rgba(122,122,120,0.08)",
          padding: "6px 14px",
          borderRadius: "50px",
          letterSpacing: "0.02em",
          textTransform: "uppercase",
        }}
      >
        {product.status}
      </span>
    </div>
  );
}
